import { useContext } from 'react';
import { CartContext } from '../../contexts/cart.context';
import {ShoppingIcon, CartIconContainer, ItemCount} from './cart-icon.styles.jsx';


const CartIcon = () => {
    const { isCartOpen, setIsCartOpen, cartTotal } = useContext(CartContext);

    const toggleIsCartOpen = () => setIsCartOpen(!isCartOpen); 

    return (
        <CartIconContainer onClick={toggleIsCartOpen}>
            <ShoppingIcon />
            <ItemCount>{cartTotal}</ItemCount>
        </CartIconContainer>
    )
}

export default CartIcon;